<div class="card">
    <div class="card-body  admin-model-height formbg-d2">
        <sms-headAdmin></sms-headAdmin>
        <div class="row d-flex justify-content-end align-items-center mr-2">

            Upload new TOC File:
            <div class="ml-2">
                <button *ngIf="showUploadButton" type="button" class="btn btn-secondary"
                    (click)="Open(content)">Upload</button>
            </div>

        </div>
        <h3 class="text-green"> Existing TOC Files list:</h3>

        <table class="table">
            <thead>
                <tr>
                    <th>File Name</th>
                    <th>Preview</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor='let termsandConditonList of TermsandConditonList'>
                    <td>{{ termsandConditonList.fileName }}</td>
                    <td>
                        <img src="data:image/jpeg;base64,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"
                            height="18" size="18" (click)="Perview(termsandConditonList.perviewURL)" alt="">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<ng-template #content let-modal let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title"><b>Upload Terms And Condition</b></h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body formbg-d2">
        <div class="form-group row">
            <div class="col-sm-4">
                <span>Upload File</span>
            </div>
            <div class="col-sm-6 p-0">
                <input type="file" accept=".html,.htm" #UploadTOC class="d-none" (change)="upload(UploadTOC.files)">
                <button type="button" class="btn btn-secondary" (click)="UploadTOC.click()">...</button>
            </div>
        </div>

        <div class="form-group row">
            <label for="AgencyLanguage" class="col-sm-4 col-form-label">Select Agency Language</label>
            <select id="AgencyLanguage" class="col-sm-6 form-control" [(ngModel)]="agencyLangSelect">
                <option [ngValue]="undefined" disabled selected> Please select lanaguage... </option>
                <option *ngFor="let agencyLang of AgencyLanaguage" [value]='agencyLang.languageID'>
                    {{ agencyLang.languageName }}</option>
            </select>
        </div>
        <div class="form-group row">
            <label for="SelectDevice" class="col-sm-4 col-form-label">Select Device</label>
            <select id="SelectDevice" class="col-sm-6 form-control" [(ngModel)]="DeviceSelect">
                <option [ngValue]="undefined" disabled selected> Please select device... </option>
                <option *ngFor="let device of Device" [value]='device'>{{ device }}</option>
            </select>
        </div>
        <div class="text-right"> <button type="button" class="btn btn-secondary"
                (click)="UploadTOCDoc()">Upload</button></div>
    </div>
</ng-template>